import { useEffect, useRef, useState } from 'react';
import { AssetActor } from '../services/assetActor';
import { Balance, OrderBook, TokenStats, Trade } from '../types';

export function useAssetActor(actor: AssetActor | null) {
    const [orderBook, setOrderBook] = useState<OrderBook | null>(null);
    const [trades, setTrades] = useState<Trade[]>([]);
    const [balance, setBalance] = useState<Balance | null>(null);
    const [tokenStats, setTokenStats] = useState<TokenStats | null>(null);
    const [updateCounter, setUpdateCounter] = useState(0);
    const [isConnected, setIsConnected] = useState(false);

    const animationFrameId = useRef<number | null>(null);

    useEffect(() => {
        if (!actor) {
            setOrderBook(null);
            setTrades([]);
            setBalance(null);
            setIsConnected(false);
            return;
        }

	const updateState = () => {
            setOrderBook(actor.getOrderBook());
            setTrades(actor.getTrades());
            setBalance(actor.getBalance());
            setTokenStats(actor.getTokenStats());
            setIsConnected(actor.isWebSocketConnected());
	};

	// update initial state
	updateState();

        // subscribe to updates but throttle the updates by requesting an animation frame
	const unsubscribe = actor.subscribe(() => {
	    if (animationFrameId.current === null) {
		animationFrameId.current = requestAnimationFrame(() => {
		    updateState();
            	    setUpdateCounter(prev => prev + 1);
		    animationFrameId.current = null;
		});
	    }
	});
	
        return () => {
	    unsubscribe();
	    if (animationFrameId.current !== null) {
		cancelAnimationFrame(animationFrameId.current);
		animationFrameId.current = null;
	    }
	};
    }, [actor]);

    return {
        orderBook,
        trades,
	balance,
	tokenStats,
        updateCounter, // For debugging - shows how many updates we've received
        asset: actor?.getAsset() || null,
        isActive: actor?.isActorActive() || false,
        isConnected, // WebSocket connection status
    };
} 

